document.addEventListener('DOMContentLoaded', function () {
  'use strict';

  var expectedClass = window.Shopify && window.Shopify.currency && window.Shopify.currency.active === 'SAR' ? 'rev-sar' : 'rev-aed';
  var currencyPattern = new RegExp(
    "<span\\s+class\\s*=\\s*['\"]?rev-(aed|sar)['\"]?\\s*>([\\s\\S]*?)<\\/span>",
    "gi"
  );
  var dynamicRoot = document.getElementById('MainContent') || document.body;
  var pending = new Set();
  var frameId = 0;

  function createCurrencySpan(value) {
    var span = document.createElement('span');
    span.className = expectedClass;
    span.textContent = String(value).trim();
    return span;
  }

  function repairTextNode(textNode) {
    var value = textNode.nodeValue;
    if (!value || value.indexOf('<span') === -1 || !currencyPattern.test(value)) return;

    currencyPattern.lastIndex = 0;
    var fragment = document.createDocumentFragment();
    var cursor = 0;
    var match;

    while ((match = currencyPattern.exec(value)) !== null) {
      if (match.index > cursor) {
        fragment.appendChild(document.createTextNode(value.slice(cursor, match.index)));
      }
      fragment.appendChild(createCurrencySpan(match[2]));
      cursor = match.index + match[0].length;
    }

    if (cursor < value.length) {
      fragment.appendChild(document.createTextNode(value.slice(cursor)));
    }

    textNode.parentNode.replaceChild(fragment, textNode);
  }

  function repairCurrencyMarkup(root) {
    if (!root) return;

    if (root.nodeType === Node.TEXT_NODE) {
      repairTextNode(root);
      return;
    }

    if (root.nodeType !== Node.ELEMENT_NODE) return;

    root.querySelectorAll('.rev-aed, .rev-sar').forEach(function (element) {
      element.classList.remove('rev-aed', 'rev-sar');
      element.classList.add(expectedClass);
    });

    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        return node.nodeValue && node.nodeValue.indexOf('<span') !== -1
          ? NodeFilter.FILTER_ACCEPT
          : NodeFilter.FILTER_REJECT;
      }
    });

    var nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(repairTextNode);
  }

  function flush() {
    frameId = 0;
    pending.forEach(repairCurrencyMarkup);
    pending.clear();
  }

  function queue(node) {
    if (!node) return;
    pending.add(node.nodeType === Node.TEXT_NODE ? node.parentElement : node);
    if (!frameId) frameId = window.requestAnimationFrame(flush);
  }

  repairCurrencyMarkup(dynamicRoot);

  document.addEventListener('shopify:section:load', function (event) {
    repairCurrencyMarkup(event.target);
  });

  document.addEventListener('cart:updated', function () {
    var cartDrawer = document.getElementById('halo-cart-sidebar') || document.querySelector('.cart-drawer');
    if (cartDrawer) repairCurrencyMarkup(cartDrawer);
  });
});
